import { render, staticRenderFns } from "./UnitOfMeasure.vue?vue&type=template&id=10e37294"
import script from "./UnitOfMeasure.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports